export const TENANT_SETTINGS_TAG_TYPES = {
  GENERAL_INFORMATION: 'TenantGeneralInformationInfo',
  ONBOARDING: 'TenantOnboardingInfo',
  USER_STATUS: 'TenantUserStatusInfo',
  SURVEY: 'TenantSurveyInfo',
  THEME: 'TenantThemeInfo',
  TUTORIAL: 'TenantTutorialInfo',
  TRANSIT_VALIDATION: 'TenantTransitValidationInfo',
  ADDITIONAL_INFORMATION: 'TenantAdditionalInformationInfo',
  FRIEND_REFERRAL: 'TenantFriendReferralInfo'
} as const

export type TenantSettingsPageTag =
  | (typeof TENANT_SETTINGS_TAG_TYPES)['GENERAL_INFORMATION']
  | (typeof TENANT_SETTINGS_TAG_TYPES)['ONBOARDING']
  | (typeof TENANT_SETTINGS_TAG_TYPES)['USER_STATUS']
  | (typeof TENANT_SETTINGS_TAG_TYPES)['SURVEY']
  | (typeof TENANT_SETTINGS_TAG_TYPES)['THEME']
  | (typeof TENANT_SETTINGS_TAG_TYPES)['TUTORIAL']
  | (typeof TENANT_SETTINGS_TAG_TYPES)['TRANSIT_VALIDATION']
  | (typeof TENANT_SETTINGS_TAG_TYPES)['ADDITIONAL_INFORMATION']
  | (typeof TENANT_SETTINGS_TAG_TYPES)['FRIEND_REFERRAL']

export const TENANT_SETTINGS_REST_PATHS = {
  GENERAL_INFORMATION: '/general-information',
  ONBOARDING: '/onboarding',
  USER_STATUS: '/user-status',
  SURVEY: '/survey',
  THEME: '/theme',
  TUTORIAL: '/tutorial',
  TRANSIT_VALIDATION: '/transit-validation',
  ADDITIONAL_INFORMATION: '/additional-information',
  FRIEND_REFERRAL: '/friend-referral'
} as const
